var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSymbolFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.6458 0L82.262 0L82.262 50.2644L63.3745 3.68926L49.1109 9.45214L68.6157 57.7283L31.8372 20.9029L20.9592 31.7809L56.6037 67.4596L10.1882 47.7224L4.17724 61.8833L52.1226 82.262L0 82.2621L0 97.6459L50.2591 97.7107L3.65476 116.54L9.41765 130.804L57.8024 111.328L20.911 148.219L31.781 159.089L67.4514 123.45L47.751 169.861L61.9015 175.867L82.262 127.959L82.262 180L97.6458 180L97.7107 129.741L116.54 176.345L130.804 170.582L111.333 122.211L148.197 159.097L159.075 148.219L123.4 112.534L169.844 132.265L175.855 118.104L127.836 97.7132L180 97.6459L180 82.2621L129.736 82.262L176.311 63.3745L170.548 49.1109L122.325 68.5943L159.089 31.781L148.219 20.911L112.633 56.4974L120.271 38.5254L106.085 32.4335L97.7131 52.1575L97.6458 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.099 4.13251L112.092 18.283L126.243 24.2895L132.249 10.139L118.099 4.13251Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolFull);
export default __webpack_public_path__ + "static/media/symbol-full.478bed4417c2119e09a0bac8fa8f0fcf.svg";
export { ForwardRef as ReactComponent };